import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import { requestResetCode, setPassword } from '../Networking/PasswordRecovery';
import { verifyResetCode } from '../Networking/PasswordRecovery';
import Typography from '@material-ui/core/Typography';

const progressStyle = {
    marginTop: 40,
    marginBottom: 31,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
};

const editTextStyle = {
    width: '100%'
}

const passwordStyle = {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
}

const passwordHelperTextStyle = {
    marginTop: 5,
    color: '#f44336',
    padding: 0,
}

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

let updatePage;
let self;
let currentEmail;
let currentValueCodeOrEmail;
let currentExecuteId;
let t;

/**
 * Password recovery is done in 3 steps:
 * 1) requestResetCode(emailOrValueCode)
 *    A reset code is emailed to the entered email or
 *    to the email registered to the entered value code.
 *    If value code is entered, the user is shown a
 *    preview of the registered email.
 * 
 * 2) verifyResetCode(emailOrValueCode, executeId)
 *    The user enters the code (executeId) received on email.
 *    If the entered code is correct, the user is taken
 *    to step 3.
 * 
 * 3) setPassword(emailOrValueCode, executeId, password)
 *    Set the password for given email or value code
 */
class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        self = this;
        updatePage = props.updatePage;
        t = props.getTranslation;

        this.state = {
            /*
            Pages states:
                1) requestResetCode
                2) verifyResetCode
                3) setPassword
                4) feedback page (success or failure)
            */
            currentPageState: 1,
            success: false,
            waitingForResponse: false,
            userTextField: {
                value: '',
                error: false,
                helperText: '',
            },
            resetCodeTextField: {
                value: '',
                error: false,
                helperText: '',
            },
            passwordTextField: {
                value: '',
                error: false,
                helperText: '',
                showPassword: false
            },
            repeatPasswordTextField: {
                value: '',
                error: false,
                helperText: '',
                showPassword: false
            }
        }
    }


    onCancelClicked = e => {
        e.preventDefault();

        /*
            Todo: Could potentially set state to previous login state for state 2 and 3,
            but just going back to the login page is fine to begin with.
        */
        switch (this.state.currentPageState) {
            case 1:
                updatePage('login');
                break;
            case 2:
                updatePage('login');
                break;
            case 3:
                updatePage('login');
                break;
            case 4:
                updatePage('login');
                break;
            default:
                updatePage('login');
                break;
        }
    }

    onSendClicked = e => {
        e.preventDefault();

        const onOk = function onOk(registered, email) {
            if (registered) {
                /*
                Api should ideally return the email here both for value code and for email.
                As of 06.08.18, it only returns starred out email if value code is input.
                We must therefore check if email is null, and set it to the one in the input
                if it is.
                */
                if (email == null) {
                    currentEmail = self.state.userTextField.value;
                    currentValueCodeOrEmail = self.state.userTextField.value;
                } else {
                    // Todo: Verify that this is correct
                    /*
                     If the email returned for a registered user is null, we know that
                     the user has input a value code to begin with.
                    */
                    currentEmail = email;
                    currentValueCodeOrEmail = self.state.userTextField.value;
                }

                self.setState({
                    currentPageState: 2,
                    waitingForResponse: false,
                    userTextField: {
                        value: '',
                        error: false,
                        helperText: '',
                    }
                });
            } else {
                console.log("Not registered");
                self.setState({
                    waitingForResponse: false,
                    userTextField: {
                        value: '',
                        error: true,
                        helperText: t('invalid_email_or_value_code')
                    }
                });
            }
        };

        const onError = function onError() {

        };

        // Request reset code
        if (!isEmpty(this.state.userTextField.value)) {
            self.setState({
                waitingForResponse: true
            });
            requestResetCode(self.state.userTextField.value, self.props.credentials, onOk, onError);
        }
    }

    onVerifyClicked = e => {
        e.preventDefault();

        const onOk = function onOk(can_reset_password, wrong_execute_id, execute_id_expired, execute_id_used) {
            if (can_reset_password) {

                // Todo: Set earlier and also pass this to verifyResetCode?
                currentExecuteId = self.state.resetCodeTextField.value;

                self.setState({
                    currentPageState: 3,
                    waitingForResponse: false,
                    resetCodeTextField: {
                        value: '',
                        error: false,
                        helperText: '',
                    }
                });
            } else {
                let feedbackText = '';
                if (wrong_execute_id) {
                    feedbackText = t('wrong_execute_id');
                } else if (execute_id_expired) {
                    feedbackText = t('execute_id_expired');
                } else if (execute_id_used) {
                    feedbackText = t('execute_id_used');
                }
                self.setState({
                    waitingForResponse: false,
                    resetCodeTextField: {
                        value: '',
                        error: true,
                        helperText: feedbackText
                    }
                });
            }
        };

        const onError = function onError() {

        };

        // Verify reset code
        if (!isEmpty(this.state.resetCodeTextField.value)) {
            self.setState({
                waitingForResponse: true
            });
            verifyResetCode(currentValueCodeOrEmail, this.state.resetCodeTextField.value, self.props.credentials, onOk, onError);
        }
    }

    onSaveClicked = e => {
        e.preventDefault();

        const onOk = function onOk(success) {
            self.setState({
                currentPageState: 4,
                success: success
            });
        };

        const onError = function onError() {
            self.setState({
                currentPageState: 4,
                success: false
            });
        };

        // Set password if fields match and are not empty
        if (!isEmpty(this.state.passwordTextField.value) && !isEmpty(this.state.repeatPasswordTextField.value) && this.state.passwordTextField.value === this.state.repeatPasswordTextField.value) {
            self.setState({
                waitingForResponse: true
            });
            setPassword(currentValueCodeOrEmail, currentExecuteId, this.state.passwordTextField.value, onOk, onError);
        } else {
            self.setState((prevState) => {
                return {
                    passwordTextField: {
                        value: prevState.passwordTextField.value,
                        error: true,
                        helperText: t('passwords_must_match'),
                        showPassword: prevState.passwordTextField.showPassword
                    },
                    repeatPasswordTextField: {
                        value: prevState.repeatPasswordTextField.value,
                        error: true,
                        helperText: t('passwords_must_match'),
                        showPassword: prevState.repeatPasswordTextField.showPassword
                    }
                }
            });
        }
    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState((prevState) => {
            return {
                passwordTextField: {
                    value: prevState.passwordTextField.value,
                    error: prevState.passwordTextField.error,
                    helperText: prevState.passwordTextField.helperText,
                    showPassword: !prevState.passwordTextField.showPassword
                }
            }
        });
    };

    handleClickShowRepeatPassword = () => {
        this.setState((prevState) => {
            return {
                repeatPasswordTextField: {
                    value: prevState.repeatPasswordTextField.value,
                    error: prevState.repeatPasswordTextField.error,
                    helperText: prevState.repeatPasswordTextField.helperText,
                    showPassword: !prevState.repeatPasswordTextField.showPassword
                }
            }
        });
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };


    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    render() {
        let content;
        switch (this.state.currentPageState) {
            case 1:
                content =
                    <div>
                        <div className="typography-title-container">
                            <Typography variant="title">
                                {t('reset_password')}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="subheading">
                                {t('request_reset_code_text')}
                            </Typography>
                        </div>
                        <div>
                            <TextField
                                value={this.state.userTextField.value}
                                error={this.state.userTextField.error}
                                helperText={this.state.userTextField.helperText}
                                id="userTextField"
                                label={t('email_or_value_code')}
                                onChange={this.handleChange('userTextField')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                style={editTextStyle}
                                margin="normal" />
                        </div>
                        {this.state.waitingForResponse ?
                            <LinearProgress style={progressStyle} color="primary" variant="query" />
                            :
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="text"
                                    color="default"
                                    onClick={e => this.onCancelClicked(e)}>
                                    {t('cancel')}
                                </Button >
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.onSendClicked(e)}>
                                    {t('send')}
                                </Button >
                            </div>
                        }
                    </div>
                break;
            case 2:
                content =
                    <div>
                        <div className="typography-title-container">
                            <Typography variant="title">
                                {t('enter_code')}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="subheading">
                                {t('check_the_inbox_of')} {currentEmail}, {t('and_enter_the_6_digit_code_below')}
                            </Typography>
                        </div>
                        <div>
                            <TextField
                                value={this.state.resetCodeTextField.value}
                                error={this.state.resetCodeTextField.error}
                                helperText={this.state.resetCodeTextField.helperText}
                                type='number'
                                id="resetCodeTextField"
                                label={t('code')}
                                onChange={this.handleChange('resetCodeTextField')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                style={editTextStyle}
                                margin="normal" />
                        </div>
                        {this.state.waitingForResponse ?
                            <LinearProgress style={progressStyle} color="primary" variant="query" />
                            :
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="text"
                                    color="default"
                                    onClick={e => this.onCancelClicked(e)}>
                                    {t('cancel')}
                                </Button >
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.onVerifyClicked(e)}>
                                    {t('verify')}
                                </Button >
                            </div>
                        }
                    </div>
                break;
            case 3:
                content =
                    <div>
                        <div className="typography-title-container">
                            <Typography variant="title">
                                {t('new_password')}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="subheading">
                                {t('input_your_desired_password')}
                            </Typography>
                        </div>
                        <FormControl style={passwordStyle}>
                            <InputLabel htmlFor="passwordTextField">{t('new_password')}</InputLabel>
                            <Input
                                id="passwordTextField"
                                type={this.state.passwordTextField.showPassword ? 'text' : 'password'}
                                value={this.state.passwordTextField.value}
                                error={this.state.passwordTextField.error}
                                onChange={this.handleChange('passwordTextField')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this.handleClickShowPassword}
                                            onMouseDown={this.handleMouseDownPassword}>
                                            {this.state.passwordTextField.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <FormControl style={passwordStyle}>
                            <InputLabel htmlFor="repeatPasswordTextField">{t('repeat_new_password')}</InputLabel>
                            <Input
                                id="repeatPasswordTextField"
                                type={this.state.repeatPasswordTextField.showPassword ? 'text' : 'password'}
                                value={this.state.repeatPasswordTextField.value}
                                error={this.state.repeatPasswordTextField.error}
                                onChange={this.handleChange('repeatPasswordTextField')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this.handleClickShowRepeatPassword}
                                            onMouseDown={this.handleMouseDownPassword}>
                                            {this.state.repeatPasswordTextField.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                            <FormHelperText style={passwordHelperTextStyle} id="weight-helper-text">{this.state.repeatPasswordTextField.helperText}</FormHelperText>
                        </FormControl>
                        {this.state.waitingForResponse ?
                            <LinearProgress style={progressStyle} color="primary" variant="query" />
                            :
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="text"
                                    color="default"
                                    onClick={e => this.onCancelClicked(e)}>
                                    {t('cancel')}
                                </Button >
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.onSaveClicked(e)}>
                                    {t('save')}
                                </Button >
                            </div>
                        }
                    </div>
                break;
            case 4:
                content =
                    <div>
                        <div className="typography-title-container">
                            <Typography variant="title" color={this.state.success ? "default" : "error"}>
                                {this.state.success ? t('password_changed_title') : t('password_change_failed_title')}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="subheading">
                                {this.state.success ? t('password_changed_message') : t('password_recovery_change_failed_message')}
                            </Typography>
                        </div>
                        <div style={buttonContainerStyle}>
                            <Button
                                style={buttonStyle}
                                variant="contained"
                                color="primary"
                                onClick={e => this.onCancelClicked(e)}>
                                {t('done')}
                            </Button >
                        </div>
                    </div>;
                break;
            default:
                break;
        }

        const root =
            <div className="Login">
                <Paper className="login-content">
                    <div className="content-container-paper">
                        {content}
                    </div>
                </Paper>
            </div>;

        return root;
    }
}

function isEmpty(value) {
    return value === '';
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/Pages/ForgotPassword.js